module.exports = __webpack_public_path__ + "assets/images/01R.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/01R.png
// module id = 1257
// module chunks = 1